module.exports = __webpack_public_path__ + "img/card-2a-3a-report.91e59445.svg";